import { render, staticRenderFns } from "./GoodsSelector.vue?vue&type=template&id=b5fc40c0&scoped=true&"
import script from "./GoodsSelector.vue?vue&type=script&lang=js&"
export * from "./GoodsSelector.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSelector.vue?vue&type=style&index=0&id=b5fc40c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fc40c0",
  null
  
)

export default component.exports